import { ResponseError } from '../../errors';
import { IGetSeoDataRequest, TGetSeoDataResponse, fetchGetSeoData } from '../../repositories/seo-urls/v1/get-seo-data';
import { IApplicationContext } from '../../types/applicationContext';
import { ISeoData } from '../../types/seo/pageData';

export async function fetchSeoData(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetSeoDataRequest,
): Promise<ISeoData | null> {
  try {
    const { response, statusCode }: TGetSeoDataResponse = await fetchGetSeoData({ httpApi, parameters });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchSeoData',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (error) {
    logger.warning(error);

    return null;
  }
}
